import React, { Component } from 'react'
import Img from 'gatsby-image'
import Link from 'gatsby-link'
import styled from 'styled-components'
import Headroom from 'react-headroom'

const Nav = styled(Headroom)`
  z-index: 9000;
  position: relative;

  .headroom {
    box-shadow: 0px 0px 0px transparent;
    transition: box-shadow 300ms ease;
  }
  .headroom--pinned.headroom--scrolled {
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.5);
  }

  .navbar-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .navbar-item.has-text-dark {
    span {
      transition: border-bottom 300ms ease;
      border-bottom: solid 0px transparent;
    }
    &:hover {
      span {
        width: 100%;
        border-bottom: solid 2px #9beaed;
        transition: border-bottom 100ms cubic-bezier(0.1, 0.7, 1, 0.1);
      }
    }
  }
  .active {
    font-weight: 500;
    span {
      width: 100%;
      border-bottom: solid 2px #9beaed !important;
    }
  }
`

class Header extends React.Component {
  constructor() {
    super()
    this.state = {
      navToggle: false,
    }
    // this.toggle = this.toggle.bind(this)
  }

  toggle() {
    if (this.state.navToggle == false) {
      this.setState({
        navToggle: true,
      })
    } else if (this.state.navToggle == true) {
      this.setState({
        navToggle: false,
      })
    } else {
      return null
    }
  }
  linkClick() {
    this.setState({
      navToggle: false,
    })
  }

  render() {
    const header = this.props.header
    return (
      <Nav className="">
        <nav
          className="navbar is-primary is-transparent"
          role="navigation"
          aria-label="main-navigation"
        >
          <div className="container">
            <div className="navbar-brand level is-mobile is-marginless">
              <div className="level-left">
                <Link
                  className="navbar-item level-item"
                  to="/"
                  onClick={() => this.linkClick()}
                >
                  {/* <Img resolutions={header.datoCmsMenu.logo.resolutions} /> */}
                  <img src={header.datoCmsMenu.logo.url} alt="" />
                </Link>
              </div>
              <div className="level-right">
                <div
                  className={
                    this.state.navToggle == true
                      ? 'is-active navbar-burger level-item'
                      : 'navbar-burger level-item'
                  }
                  onClick={() => this.toggle()}
                >
                  <span />
                  <span />
                  <span />
                </div>
              </div>
            </div>
            <div
              className={
                this.state.navToggle == true
                  ? ' is-active navbar-menu'
                  : 'navbar-menu'
              }
            >
              <div className="navbar-start" />
              <div className="navbar-end">
                <Link
                  className={
                    (this.props.location.pathname == '/services'
                      ? 'active '
                      : '') + 'navbar-item has-text-dark'
                  }
                  to="/services"
                  onClick={() => this.linkClick()}
                >
                  Services
                  <span />
                </Link>
                <Link
                  className={
                    (this.props.location.pathname == '/about'
                      ? 'active '
                      : '') + 'navbar-item has-text-dark'
                  }
                  to="/about"
                  onClick={() => this.linkClick()}
                >
                  About
                  <span />
                </Link>
                <Link
                  className={
                    (this.props.location.pathname == '/work' ? 'active ' : '') +
                    'navbar-item has-text-dark'
                  }
                  to="/work"
                  onClick={() => this.linkClick()}
                >
                  Work
                  <span />
                </Link>
                <Link
                  className={
                    (this.props.location.pathname == '/blog' ||
                    this.props.location.pathname.match('/blog/')
                      ? 'active '
                      : '') + 'navbar-item has-text-dark'
                  }
                  to="/blog"
                  onClick={() => this.linkClick()}
                >
                  Blog
                  <span />
                </Link>
                <div className="navbar-item">
                  <Link
                    className="button is-dark"
                    to="/contact"
                    onClick={() => this.linkClick()}
                  >
                    Contact
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </Nav>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js